var uiKit = {
  datepicker: {
    sunday: 'Воскресенье',
    monday: 'Понедельник',
    tuesday: 'Вторник',
    wednesday: 'Среда',
    thursday: 'Четверг',
    friday: 'Пятница',
    saturday: 'Суббота',
    sunday_short: 'Вс',
    monday_short: 'Пн',
    tuesday_short: 'Вт',
    wednesday_short: 'Ср',
    thursday_short: 'Чт',
    friday_short: 'Пт',
    saturday_short: 'Сб',
    january: 'Январь',
    february: 'Февраль',
    march: 'Март',
    april: 'Апрель',
    may: 'Май',
    june: 'Июнь',
    july: 'Июль',
    august: 'Август',
    september: 'Сентябрь',
    october: 'Октябрь',
    november: 'Ноябрь',
    december: 'Декабрь',
    pick_year: 'Выберите год',
    pick_month: 'Выберите месяц',
    pick_date: 'Выберите день'
  }
};

export default {
  myaccount: {
    welcomeBar: {
      hi: 'Здравствуйте',
      lastLogin: 'Последний логин',
      fullDate: '{{year}}-{{month}}-{{day}} {{hour}}',
      months: {
        '01': '01',
        '02': '02',
        '03': '03',
        '04': '04',
        '05': '05',
        '06': '06',
        '07': '07',
        '08': '08',
        '09': '09',
        10: '10',
        11: '11',
        12: '12'
      }
    },
    accountInfo: {
      id: 'ID'
    },
    navigationMenu: {
      title: {
        myBets: 'Мои ставки',
        accountHistory: 'История счета',
        withdraw: 'Вывод',
        reversalWithdraw: 'Отменить вывод',
        myRewards: 'Акции',
        myAccount: 'Мой счет',
        depositLimit: 'Лимиты на депозит',
        deposit: 'Депозит',
        gamblingControls: 'Контроль моей игры',
        saferGambling: 'Безопасная игра',
        pokerBalanceTransfer: 'Перевод средств'
      }
    },
    profitAndLoss: {
      title: 'Прибыли и Убытки',
      description: {
        up: 'Вы на {{value}} больше в этом месяце',
        down: 'Вы потеряли {{value}} в этом месяце'
      }
    },
    myAccountTitles: {
      title: {
        accountHistory: 'История счета',
        personalDetails: 'Личные данные',
        loginSecuritySettings: 'Логин и настройки безопасности',
        siteSettings: 'Настройки сайта'
      },
      listItems: {
        autoLogin: 'Авто-логин',
        contactDetails: 'Контактные данные',
        contactName: 'Полное имя',
        marketingPreferences: 'Маркетинговые предпочтения',
        oddsFormat: 'Виды коэффициентов',
        password: 'Пароль',
        statementsView: 'Показать транзакции',
        summaries: 'Информация о чистом депозите',
        twoFactorAuth: '2-факторная аутентификация'
      }
    },

    saferGambling: {
      tilesConfig: {
        header: {
          text: 'Азартные игры должны приносить удовольствие. Мы создали несколько полезных инструментов, которые помогут контролировать, сколько Вы тратите.'
        },

        footer: {
          text: 'Узнайте больше о том, что мы делаем, чтобы помочь',
          link: 'Безопасная игра'
        },

        selfAssessment: {
          title: 'Опрос',
          description: 'Используйте этот опрос, чтобы отслеживать свои игровые привычки. Это займет всего 2 минуты!'
        },
        depositLimits: {
          title: 'Лимиты на депозит',
          description: 'Установите дневной, недельный или месячный лимит средств, которые Вы можете внести на свой счет'
        },

        gamingTimeReminder: {
          title: 'Таймер длительности игры',
          description: 'Доступно только для игр и казино. Настройте уведомления, которые будут показывать как долго Вы играете.'
        },

        timeOut: {
          title: 'Тайм-аут',
          descriptionUk: 'Возьмите перерыв от азартных игр. Это может быть период до 42 дней.',
          descriptionNonUk: 'Сделайте перерыв в игре с нами. Это может быть любой период времени до 6 месяцев.'
        },

        accountClosure: {
          title: 'Закрытие счета',
          description: 'Нам жаль, что Вы решили закрыть свой аккаунт. Вы можете сделать это здесь.'
        },

        selfExclusion: {
          title: 'Самоисключение',
          description: 'Закройте свой аккаунт на срок от шести месяцев до пяти лет.'
        },
        profitAndLoss: {
          title: 'Прибыли и Убытки',
          description: {
            up: 'Вы на {{value}} больше в этом месяце',
            down: 'Вы потеряли {{value}} в этом месяце'
          }
        }
      },

      views: {
        depositLimits: {
          day: 'день',
          week: 'неделя',
          month: 'месяц',
          viewHeader: {
            title: 'Установить лимит на депозит',
            content: 'Установите дневной, недельный или месячный лимит на депозит.<br>' + '<a href="https://williamhill-ru.custhelp.com/app/answers/detail/a_id/18196" rel="noopener noreferrer" target="_blank">Как это работает?</a>'
          },
          limits: {
            daily: 'Дневной лимит',
            weekly: 'Недельный лимит',
            monthly: 'Месячный лимит'
          },
          periods: {
            day: 'дневной',
            week: 'недельный',
            month: 'месячный'
          },
          buttonText: 'Сохранить  лимиты на депозит',
          chooseLimit: 'Выбрать лимит',
          valueNotSet: 'Не установлен',
          noLimit: 'Нет лимита',
          noLimitSet: 'Лимит не установлен',
          remainingDeposit: {
            day: 'Оставшаяся сумма, которую можно внести в день, составляет {{amount}}',
            week: 'Оставшаяся сумма, которую можно внести в неделя, составляет {{amount}}',
            month: 'Оставшаяся сумма, которую можно внести в месяц, составляет {{amount}}'
          },
          emptyRemainingDeposit: 'У Вас нет лимитов на депозит',
          successMessage: 'Лимиты на депозит успешно обновлены',
          confirmationButton: 'Подтвердите увеличение депозита до {{amount}}',
          confirmationButtonNoLimit: 'Подтвердите увеличение депозита до "нет лимита"',
          confirmationMessage: {
            day: 'Ваш дневной лимит {{amount}} будет доступен для подтверждения {{date}} в {{time}} (Время по Великобритании).<br><br>' + 'Вы можете отменить действие, <a href="#">нажав здесь</a>',
            week: 'Ваш недельный лимит {{amount}} будет доступен для подтверждения {{date}} в {{time}} (Время по Великобритании).<br><br>' + 'Вы можете отменить действие, <a href="#">нажав здесь</a>',
            month: 'Ваш месячный лимит {{amount}} будет доступен для подтверждения {{date}} в {{time}} (Время по Великобритании).<br><br>' + 'Вы можете отменить действие, <a href="#">нажав здесь</a>'
          },
          confirmationMessageNoLimit: {
            day: 'Ваш дневной лимит "нет лимита" будет доступен для подтверждения {{date}} в {{time}} (Время по Великобритании).<br><br>' + 'Вы можете отменить действие, <a href="#">нажав здесь</a>',
            week: 'Ваш недельный лимит "нет лимита" будет доступен для подтверждения {{date}} в {{time}} (Время по Великобритании).<br><br>' + 'Вы можете отменить действие, <a href="#">нажав здесь</a>',
            month: 'Ваш месячный лимит "нет лимита" будет доступен для подтверждения {{date}} в {{time}} (Время по Великобритании).<br><br>' + 'Вы можете отменить действие, <a href="#">нажав здесь</a>'
          },
          confirmationSuccessful: 'Лимит на депозит успешн обновлён',
          increaseWarning: 'Если Вы хотите увеличить свой лимит, то Вам необходимо будет подтвердить это в течение 24 часов.',
          footerContent: 'Не нашли лимит, который Вы хотите установить?<br/>' + '<a href="https://williamhill-ru.custhelp.com/app/ask" rel="noopener noreferrer" target="_blank">Свяжитесь со службой поддержки клиентов</а>',
          cancellationModalContent: 'Вы уверены, что хотите отменить увеличение лимита на депозит?'
        },

        gamingTimeReminder: {
          accordionText: 'Таймер длительности игры',
          currentReminder: 'Текущее напоминание:',
          reminders: {
            placeholder: 'Выберите период времени',
            noReminder: 'Таймер не установлен',
            minutes: '{{time}} минут(-ы)',
            hour: '{{time}} час',
            hours: '{{time}} часa(-ов)'
          },
          submitButton: 'Сохранить напоминание',
          warningMessage: 'Время напоминания вступит в силу после завершения напоминания о текущей сессии или закрытия активных игр.',
          successMessage: 'Таймер длительности игры успешно обновлен',
          viewHeader: {
            title: 'Установить Таймер игровой сессии',
            content: '<p>Установите автоматическое напоминание, сообщающее, как долго Вы играете.</p><a href="https://williamhill-lang.custhelp.com/app/answers/detail/a_id/8197/#restrict_account" rel="noopener noreferrer" target ="_blank"> Как это работает?</a></br></br>' + '<p>Данная опция доступна только для игровых продуктов. Обратите внимание, что игровые продукты не включают в себя спортивные ставки, покер, виртуальные или бесплатные турниры. Чтобы установить напоминание для  Evolution Gaming, запустите игру, выберите «Настройки», а затем «Настройки игровой сессии»</p>'
          },
          valueNotSet: 'Не установлено'
        },

        timeOut: {
          viewHeader: {
            title: 'Установить тайм-аут',
            contentUk: 'Если Вы хотите сделать перерыв в игре, мы можем установить тайм-аут до 42 дней.</br>' + '<a href="https://williamhill-lang.custhelp.com/app/answers/detail/a_id/8197/" rel="noopener noreferrer" target="_blank">Как это работает?</a>',
            contentNonUk: 'Если вы хотите отдохнуть от ставок, то можете установить тайм-аут до 6 месяцев.</br>' + '<a href="https://williamhill-lang.custhelp.com/app/answers/detail/a_id/8197/" rel="noopener noreferrer" target="_blank">Как это работает?</a>'
          },
          formLabel: 'Сколько времени Вам необходимо?',
          values: {
            placeholder: 'Выбрать период тайм-аута',
            day: '1 день',
            days: '{{amount}} дня(-ей)',
            valueNotSet: 'Без тайм-аута'
          },
          formHeader: 'Закрыть аккаунт',
          passwordPlaceholder: 'Ввести пароль',
          submitButton: 'Сохранить тайм-аут',
          viewFooter: 'Если Вы хотите запросить тайм-аут на срок более 30 дней, <a href="https://williamhill-ru.custhelp.com/app/ask" rel="noopener noreferrer" target="_blank">обратитесь в службу поддержки</a>',
          resultPage: {
            title: 'Ваш аккаунт на Тайм-ауте',
            information: 'Вы не будете иметь доступ к аккаунту в течение {{period}} дня(-ей).',
            helpSectionMainText: 'Чтобы взять эффективный перерыв, Вам необходимо удалить все приложения для ставок со своего телефона. Более подробную информацию можно найти на нашей странице ответственной игры'
          }
        },

        accountClosure: {
          header: 'Да, я хочу закрыть свой аккаунт',
          listTitle: 'Что Вам необходимо знать:',
          firstListElement: 'Если Вы хотите сделать перерыв или закрыть свой аккаунт из соображений Ответственной игры, рассмотрите <a href="https://williamhill-lang.custhelp.com/app/answers/detail/a_id/8197/" rel="noopener noreferrer" target="_blank">Тайм-аут</a> (до 6 недель) или <a href="https://williamhill-ru.custhelp.com/app/answers/detail/a_id/8197" rel="noopener noreferrer" target="_blank">Самоисключение</a>(до пяти лет)',
          secondListElement: 'Сначала убедитесь, что Вы вывели средства со своего аккаунта',
          thirdListElement: 'Обратите внимание, что мы будем хранить Ваши данные в течение не менее 5 лет, см. нашу <a href="https://williamhill-ru.custhelp.com/app/answers/detail/a_id/8305" rel="noopener noreferrer" target="_blank">Политику конфиденциальности </a>для получения дополнительной информации',
          formHeader: 'Закрыть аккаунт',
          closureReasonPlaceholder: 'Выбрать причину',
          passwordPlaceholder: 'Ввести пароль',
          submitButton: 'Закрыть мой аккаунт',
          reasons: {
            CLOSURE_REASON_OFFERS: 'Я не доволен вашими предложениями',
            CLOSURE_REASON_PRODUCTS: 'Я не доволен вашими продуктами',
            CLOSURE_REASON_SERVICE: 'Я не доволен вашим сервисом',
            CLOSURE_REASON_TIME: 'у меня нет времени, чтобы использовать свой Аккаунт',
            CLOSURE_REASON_CHANGES: 'Мне не нравятся последние изменения',
            CLOSURE_REASON_PROVIDER: 'Я пользуюсь услугами другой компании',
            CLOSURE_REASON_SECRET: 'Предпочитаю не отвечать'
          }
        },

        accountClosed: {
          title: 'Ваш аккаунт был закрыт',
          text: 'Чтобы запросить вывод средств, <br>' + '<a href="https://williamhill-ru.custhelp.com/app/ask" rel="noopener noreferrer" target="_blank">пожалуйста, обратитесь в службу поддержки</a><br><br>' + 'Вы можете реактивировать Ваш счет в любое время, воспользовавшись опцией "Восстановления логина".',
          helpSectionMainText: 'Если Вы хотите сделать перерыв или закрыть свой аккаунт из соображений Ответственной игры, рассмотрите время ожидания (до 6 недель) или самоисключение (до пяти лет).<br><br>' + 'Более подробную информацию можно найти на нашей странице Ответственной игры.'
        },

        gamblingHelpSection: {
          bottomSectionTitle: 'Дополнительная помощь',
          bottomSectionText: 'Есть организации, которые могут помочь с бесплатными независимыми консультациями о том, как управлять вашими азартными играми.',
          mainButtonText: 'Перейти к Более Безопасным Азартным Играм',
          bottomSectionFirstButton: 'GamCare',
          bottomSectionSecondButton: 'Анонимные Игроки',
          bottomSectionThirdButton: 'Терапия Азартных Игр',
          gamstopHeader: 'GAMSTOP',
          gamstopContent: 'Мы настоятельно рекомендуем вам удалить все мобильные приложения для азартных игр от William Hill и других поставщиков азартных игр. Вы можете попросить, чтобы вас исключили из других игорных сайтов, зарегистрированных в Великобритании, используя GAMESTOP.',
          gamstopButton: 'Перейти в GAMESTOP'
        },

        selfExclusionSelection: {
          viewHeader: {
            title: 'Установить самоисключнеие',
            content: 'Если вы считаете, что у вас могут возникнуть проблемы, и вы хотите полностью отказаться от азартных игр, мы рекомендуем использовать GAMESTOP.<br /><br />GAMESTOP помогает контролировать ваши азартные игры, исключая вас из лицензированных игорных сайтов и приложений в Великобритании на период по вашему выбору.<br /><br />Вы можете установить себе самоисключение как минимум на 6 месяцев и до 5 лет.'
          },
          gamstopButton: 'Перейти в GAMESTOP',
          selfExcludeFromWH: 'Самоисключение из William Hill'
        },

        selfExclusion: {
          viewHeader: {
            title: 'Установить самоисключнеие',
            content: 'Мы можем исключить вас из наших услуг, лишив вас доступа к нашим продуктам на срок от 6 месяцев до 5 лет.<br>' + '<a href= "https://williamhill-ru.custhelp.com/app/answers/detail/a_id/8197" rel="noopener noreferrer" target ="_ blank">Как это работает?</a><br/><br/>' + '<p>Это действие нельзя отменить ни при каких обстоятельствах, пока не истечет выбранный период самоисключения.</p>'
          },
          upperSectionLabel: 'Вы уверены, что хотите восползоваться опцией самоисключения?',
          termsMessage: 'Прося исключить вас из William Hill, вы принимаете наши {{termsMessageLink}}.<br /><br />' + 'Вы не сможете получить доступ к своей учетной записи в течение запрошенного вами периода времени, и вы не сможете повторно открыть ее до этого.',
          termsMessageLink: 'Условия и Положения', // please notice this is a part of the previous key
          formLabel: 'Сколько времени Вам необходимо?',
          upperButton: 'Да, я хочу воспользоваться опцией самоисключения',
          period: {
            months: '{{amount}} месяцев',
            year: '1 год',
            years: '{{amount}} года/лет',
            valueNotSet: 'Нет периода самоисключения',
            indefinite: 'Бессрочно (мин. 1 год)'
          },
          exclusionPeriodPlaceholder: 'Период самоисключения',
          passwordPlaceholder: 'Ввести пароль',
          submitButton: 'Запросить самоисключение',
          brandsNote: {
            text: 'Ваше соглашение об исключении с William Hill <span style="font-weight: bold;">не будет</span> автоматически применено к учетной записи, которую вы можете иметь в “888 Brands”. Поэтому, если потребуется, вам нужно будет заключить с ними новое соглашение отдельно.',
            link888: 'Самоисключение из 888.com',
            link777: 'Самоисключение из 777.com'
          }
        },

        termsAndConditions: {
          text: 'Данный документ подтверждает добровольную договоренность, достигнутую между клиентом и WHG (International) Limited, касающуюся исключения клиента из его операций по ставкам через Интернет и по телефону.<br><br><br>' + 'Клиент требует, чтобы его Учетная запись была закрыта, и ему / ей было отказано в ставках и игровой активности с помощью телефонных или интернет-ставок WHG (International) Limited на выбранный период с даты получения подтверждения запроса клиента WHG (International) Limited и того, что ему / ей не разрешается изменять, отзывать,  или отменять свое самоисключение до истечения срока действия настоящего соглашения.<br><br><br>' + 'Примечание. Исключение из интернет-операций будет осуществляться по ссылке на номер счета и адрес электронной почты, а исключение из телефонных операций - по ссылке на номер счета. Мы также предпримем разумные меры, чтобы исключить использование номеров кредитных и дебетовых карт, привязанных к счетам клиента. Мы настоятельно рекомендуем клиентам удалить все приложения, связанные с William Hill, со своих устройств.<br><br><br>' + 'В конце периода исключения или в любое время после этого он / она может пересмотреть это исключение с менеджером по обслуживанию клиентов и либо продлите его на другой указанный период, либо возобновить игру. При обращении с просьбой не продлевать исключение, он / она будет подвергаться дополнительному однодневному исключительному периоду до того, как ему будет предоставлен доступ и использование Учетной записи.',
          button: 'Я ознакомлен(а) с Правилами и Условиями'
        },

        selfExcluded: {
          title: 'Ваш счет на самоисключении',
          subtitle: {
            months: 'Вы не сможете получить доступ к своему аккаунту в течение {{amount}} месяцев.',
            year: ' Вы не сможете получить доступ к своему аккаунту в течение {{amount}} года.',
            years: 'Вы не сможете получить доступ к своему аккаунту в течение {{amount}} лет.',
            indefinite: 'Ваша учетная запись закрыта на неопределенный срок, и вы не сможете получить доступ к своей учетной записи в течение как минимум 1 годa.'
          },
          helpSectionMainText: 'Чтобы сделать полноценный перерыв, не забудьте удалить любые другие сайты или приложения для азартных игр со своих устройств. Любой оставшийся баланс будет автоматически вам возвращен. Чтобы узнать больше, перейдите на нашу страницу безопасных азартных игр.'
        },

        divider: {
          or: 'ИЛИ'
        }
      },

      valueNotSet: 'Не установлено',
      incorrectPasswordErrorMessage: 'Ваш пароль не совпадает',
      genericError: 'К сожалению, не удалось выполнить ваш запрос. Пожалуйста, попробуйте еще раз или обратитесь в Службу поддержки за помощью.'
    },

    header: {
      error: {
        message: 'Не удалось получить Ваши данные',
        retry: 'Попробовать снова'
      },
      title: {
        accountHistory: 'История счета',
        accountNetDeposit: 'Информация о чистом депозите',
        deposit: 'Депозит',
        depositLimitsPage: 'Лимиты на депозит',
        landing: 'Мой аккаунт',
        loginSecurity: 'Логин и настройки безопасности',
        myAccount: 'Мой счет',
        myBets: 'Мои ставки',
        personalDetails: 'Личные данные',
        siteSettings: 'Настройки сайта',
        summaryExport: 'Экспортировать выписку',
        saferGambling: 'Безопасная игра',
        gamingTimeReminderPage: 'Таймер длительности игры',
        accountClosure: 'Закрытие счета',
        accountClosed: 'Закрытие счета',
        timeOutResult: 'Тайм-аут',
        timeOut: 'Тайм-аут',
        termsAndConditions: 'Самоисключение',
        selfExclusionSelectionPage: 'Самоисключение',
        selfExclusionPage: 'Самоисключение',
        selfExcluded: 'Самоисключение',
        bonusLanding: 'Информация о Балансе'
      }
    },
    balanceAndBonus: {
      cashBalance: 'Баланс средств',
      additionalBalance: { sportsbook: 'Бесплатные ставки', gaming: 'Игровой бонус' },
      balanceInfoLink: 'Баланс'
    },
    bonusLanding: {
      withdrawable: {
        title: 'Выводимый баланс',
        balances: {
          mainCashBalance: { mainText: 'Денежный баланс', helperText: 'Может использоваться где угодно, кроме Покера' }, //@deprecated, use sportsbook key instead
          pokerCashBalance: { mainText: 'Покерный денежный баланс', helperText: 'Для использования только на Покере' }, //@deprecated, use poker key instead
          sportsbook: { mainText: 'Денежный баланс', helperText: 'Может использоваться где угодно, кроме Покера' },
          poker: { mainText: 'Покерный денежный Баланс', helperText: 'Для использования только на Покере' }
        }
      },
      bonus: {
        title: 'Бонусные балансы',
        balances: {
          gaming: {
            mainText: 'Гейминг',
            helperText: 'Бонусные деньги для Гейминга',
            buyInBalance: {
              mainText: 'Бай-ин баланс',
              helperText: 'Остаток денег, предназначенный для бонусов'
            },
            bonusBalance: {
              mainText: 'Бонусный баланс',
              helperText: 'Бонус и ожидающий выигрышный баланс'
            }
          },
          sportsbook: {
            mainText: 'Бесплатные ставки на Спорт',
            helperText: 'Деньги для ставок на Спорт'
          },
          bingo: { mainText: 'Бинго', helperText: 'Бонусные деньги для Бинго' },
          poker: { mainText: 'Покер', helperText: 'Бонусные деньги для Покера' }
        }
      },
      footerText: {
        gaming: 'Проверьте наши акции, чтобы узнать, какие еще гейминг бонусы доступны'
      },
      buttonText: { gaming: 'Смотреть гейминг акции' }
    },
    transactions: {
      reference: 'Реф. номер',
      aamsId: 'ID AAMS',
      eachWay: 'Двойное пари 1-{{places}} мест, {{price}} цена',
      refund: 'Возврат',
      numberOfLines: 'x {{value}} ставок',
      EW: 'Двойное пари',
      stake: 'Ставка',
      return: 'Возврат',
      bonusStake: 'Бонусная ставка',
      stakeTotal: 'Общая ставка',
      tab: {
        summary: 'Сводка',
        history: 'Транзакции'
      },
      myBets: {
        open: 'Открытые',
        settled: 'Сыгранные'
      },
      price: {
        '@ SP': '@ СТ (стартовая цена)',
        '@ Guaranteed Price': '@ Гарантированная цена ({{price}})'
      },
      accountNetDeposit: {
        buttonLabel: 'Показать',
        buttonTitle: 'Информация о чистом депозите'
      },
      lotteryBet: {
        draw: 'Ничья:',
        result: 'Результат:'
      },
      totePoolBetting: 'Тотализатор',
      bettingTerminal: 'Букмекерский терминал ',
      type: {
        BET_ACCUMULATOR_10: 'Экспресс (10)',
        BET_ACCUMULATOR_11: 'Экспресс (11)',
        BET_ACCUMULATOR_12: 'Экспресс (12)',
        BET_ACCUMULATOR_13: 'Экспресс (13)',
        BET_ACCUMULATOR_14: 'Экспресс (14)',
        BET_ACCUMULATOR_15: 'Экспресс (15)',
        BET_ACCUMULATOR_16: 'Экспресс (16)',
        BET_ACCUMULATOR_17: 'Экспресс (17)',
        BET_ACCUMULATOR_18: 'Экспресс (18)',
        BET_ACCUMULATOR_19: 'Экспресс (19)',
        BET_ACCUMULATOR_20: 'Экспресс (20)',
        BET_ACCUMULATOR_21: 'Экспресс (21)',
        BET_ACCUMULATOR_22: 'Экспресс (22)',
        BET_ACCUMULATOR_23: 'Экспресс (23)',
        BET_ACCUMULATOR_24: 'Экспресс (24)',
        BET_ACCUMULATOR_25: 'Экспресс (25)',
        BET_ACCUMULATOR_4: 'Экспресс (4)',
        BET_ACCUMULATOR_5: 'Экспресс (5)',
        BET_ACCUMULATOR_6: 'Экспресс (6)',
        BET_ACCUMULATOR_7: 'Экспресс (7)',
        BET_ACCUMULATOR_8: 'Экспресс (8)',
        BET_ACCUMULATOR_9: 'Экспресс (9)',
        BET_CANADIAN: 'Canadian',
        BET_DDB: 'Tote - Daily Double',
        BET_DOUBLE: 'Экспресс (2)',
        BET_DOUBLES: 'Экспресс (2)',
        BET_EIGHTFOLDS: 'Экспресс (8)',
        BET_EXA: 'Tote - Exacta',
        BET_FIVEFOLDS: 'Экспресс (5)',
        BET_FLG: 'Пометка',
        BET_FOURFOLDS: 'Экспресс (4)',
        BET_GOLIATH: 'Goliath',
        BET_HEINZ: 'Heinz',
        BET_LUCKY_15: 'Lucky 15',
        BET_LUCKY_31: 'Lucky 31',
        BET_LUCKY_63: 'Lucky 63',
        BET_MAN: 'Письменная ставка',
        BET_NINEFOLDS: 'Экспресс (9)',
        BET_PATENT: 'Patent',
        BET_PK3: 'Tote - Выбор 3',
        BET_PK4: 'Tote - Выбор 4',
        BET_PK6: 'Tote - Выбор 6',
        BET_PK9: 'Tote - Выбор 9',
        BET_PLC: 'Tote - Место',
        BET_QIN: 'Tote - Quinella',
        BET_ROB: 'Round Robin',
        BET_SEVENFOLDS: 'Экспресс (7)',
        BET_SHW: 'Тотализатор - показать',
        BET_SINGLE: 'Одиночная',
        BET_SIXFOLDS: 'Экспресс (6)',
        BET_SPR: 'Tote - Superfecta',
        BET_SUPER_HEINZ: 'Super Heinz',
        BET_TENFOLDS: 'Экспресс (10)',
        BET_TREBLE: 'Экспресс (3)',
        BET_TREBLES: 'Экспресс (3)',
        BET_TRI: 'Tote - Trifecta',
        BET_TRIXIE: 'Trixie',
        BET_UEXA: 'Tote - Exacta',
        BET_UJKP: 'Tote - Jackpot',
        BET_UKN: 'Ставка',
        BET_UPLC: 'Tote - Место',
        BET_UPLP: 'Tote - Placepot',
        BET_UQDP: 'Tote - Quadpot',
        BET_USC6: 'Tote - Scoop 6',
        BET_USC7: 'Tote - Super 7',
        BET_USW: 'Tote - Swinger',
        BET_UTD: 'Tote - Doppel',
        BET_UTRI: 'Tote - Trifecta',
        BET_UTT: 'Tote - Tripel',
        BET_UWIN: 'Tote - Win',
        BET_WIN: 'Tote - Win',
        BET_YANKEE: 'Yankee',
        BONUS: 'Настойка баланса',
        CASINO: 'Казино',
        DEPOSIT: 'Депозит',
        GAMES: 'Игры',
        MANUAL_ADJUSTMENT: 'Ручная настройка',
        PRIORITY_CARD_CASH: 'Cash',
        PRIORITY_CARD_CASHBACK: 'Покупка с кешбэком',
        PRIORITY_CARD_DEPOSIT: 'Депозит',
        PRIORITY_CARD_NON_CASH: 'Безналичный',
        PRIORITY_CARD_OTHER: 'Другое',
        PRIORITY_CARD_PURCHASE: 'Покупка',
        PRIORITY_CARD_QUASI_CASH: 'Quasi-cash',
        PRIORITY_CARD_REFUND: 'Возврат',
        PRIORITY_CARD_TRANSACTION: 'Платеж',
        REVERSAL: 'Отмена',
        SLOTS: 'Слоты',
        TRANSFER: 'Трансфер',
        VEGAS: 'Вегас',
        WITHDRAWAL: 'Вывод',
        POKER: 'Покер',
        BINGO: 'Бинго',
        LIVE_CASINO: 'Live Казино'
      },
      manualAdjustmentType: {
        AFFP: 'Партнерские платежи',
        AFFR: 'Партнерский рейкбэк',
        BCNV: 'Конвертация баланса',
        BETC: 'Bet Correction',
        BNJW: 'Джекпот выигрыши',
        BNKC: 'Комиссия банка',
        BONS: 'Ручной бонус',
        BPCS: 'Бонусный(ые) платеж(и)',
        BTCS: 'Трансфер(ы) баланса',
        CADJ: 'Регулировка комиссии',
        CSH: 'Регулировка наличных',
        CWIN: 'Вычтенная прибыль',
        GWCS: 'Жест(ы) доброй воли',
        GWIL: 'Жест доброй воли',
        HEDG: 'Хеджирование',
        INAC: 'Комиссия за неактивность',
        ISCS: 'Неправильный(ые) расчет(ы)',
        LFND: 'Утерянные/Застрявшие средства',
        MCM: 'Manual Cash Movement',
        ONCR: 'Регулировать',
        PGCW: 'Регулировка ГК',
        RCHQ: 'Возврат чека',
        SCHQ: 'Остановка чека',
        TFCS: 'Застрявшие средства',
        WOFF: 'Списывать'
      },
      result: {
        WIN: 'Победа',
        LOST: 'Проигрыш',
        VOIDED: 'Аннулировано',
        CASHED_IN: 'Расчитано (РМС)',
        STAKE: 'Ставка',
        CANCELED: 'Отмена',
        PLACED: 'Размещено'
      },
      paymentMethod: {
        APPLEPAY: 'Apple Pay',
        BANKTRANSFER: 'Банковский перевод',
        CARD: 'Кредитная/Дебитная карта',
        CHEQUE: 'Cheque',
        CLICK2PAY: 'Click2Pay',
        CLICKANDBUY: 'Click And Buy',
        DIRECTBANKTRANSFER: 'Прямой банковский перевод',
        ECOPAYZ: 'EcoPayz',
        ENTROPAY: 'Entropay',
        ENVOY: 'Envoy',
        EPAYVOUCHER: 'ePay Voucher',
        NETELLER: 'Neteller',
        OTHER: 'Другое',
        PAYPAL: 'Paypal',
        PAYSAFECARD: 'Paysafe Card',
        PINGIT: 'Pingit',
        PLUS: 'Plus Card',
        QUICKCASH: 'CashDirect',
        SKRILL: 'Skrill',
        UKASH: 'Ukash International',
        WESTERNUNION: 'Western Union',
        MUCHBETTER: 'MuchBetter'
      },
      sort: {
        ANYTIME_SCORECAST: 'Гол в матче и счет',
        ANYTIME_WINCAST: 'Гол в матче и победа',
        ASIAN_HANDICAP: 'Азиатский гандикап',
        BYO: 'Build #YourOdds',
        COMBINATION_FIRST_FOUR: 'Комбинация первые четыре',
        COMBINATION_FORECAST: 'Комбинированный 2-й прогноз',
        COMBINATION_QUINELLA: 'Комбинация Quinella',
        COMBINATION_TRICAST: 'Комбинированный 3-й прогноз',
        CONTINUOUS_WIN: 'Continuous Win',
        FIRST_FOUR: 'Первые четыре',
        FIRST_HALF_ASIAN_HANDICAP: 'Азиатский гандикап на 1-й тайм',
        FIRST_HALF_OUTRIGHT: 'Победитель в 1-м тайме',
        FIRST_HALF_WESTERN_HANDICAP: 'Европейский гандикап на 1-й тайм',
        FIRST_WINCAST: 'Первый гол и победа',
        FORECAST: 'Прогноз',
        HIGHER_LOWER_SPLIT_OFFER: 'Выше/Ниже (с опцией сплита)',
        HIGHER_LOWER: 'Выше/Ниже',
        INSURED_SCORECAST: 'Первый гол и счет со страховкой',
        INSURED_WINCAST: 'Первый гол и победа со страховкой',
        LAST_SCORECAST: 'Последний гол и счёт',
        LAST_WINCAST: 'Последний гол и победа',
        MATCH_HANDICAP: 'Европейский Гандикап',
        OVER_UNDER: 'Больше/Меньше',
        PERMED_FORECAST: 'Постоянный прогноз',
        PERMED_TRICAST: 'Постоянный  трикаст',
        POINTS_MARKET: 'Рынок на очки',
        QUINELLA: 'Quinella',
        REVERSE_FORECAST: 'Обратный 2-й прогноз',
        SCORECAST: 'Первый гол и счет',
        SECOND_HALF_ASIAN_HANDICAP: 'Азиатский гандикап на 2-й тайм',
        SECOND_HALF_OUTRIGHT: 'Победитель во 2-м тайме',
        SECOND_HALF_WESTERN_HANDICAP: 'Европейский гандикап на 2-й тайм',
        SIMPLE: 'Простой',
        STANDOUT_FIRST_FOUR: 'Standout первые 4',
        STANDOUT_FORECAST: 'Standout прогноз',
        STANDOUT_QUINELLA: 'Standout Quinella',
        STANDOUT_TRICAST: 'Standout Tricast',
        STRAIGHT_FORECAST: '2-й прямой прогноз',
        TRICAST_OPTIONS: 'Тройной Прогноз Options',
        TRICAST: '3-й прогноз',
        WESTERN_HANDICAP: 'Европейский гандикап',
        XTH_SCORER_SCORECAST: 'Х гол и счет',
        XTH_SCORER_WINCAST: 'Х гол и победа'
      },
      boostedBet: 'Улучшенная ставка',
      loadMore: 'Больше',
      noTransactions: 'Нет транзакций',
      resetFilters: {
        filtersApplied: 'Применить фильтры',
        removeFilters: 'Убрать все'
      },
      summary: {
        correctAsOfMidnight: 'Исправлено по состоянию на полночь',
        lastRefresh: '{{day}} {{month}} {{year}}',
        profitLoss: 'Прибыли и Убытки',
        sports: 'Ставки на Спорт',
        gaming: 'Гейминг',
        profitLossBreakdown: 'Разбивка Прибылей и Убытков',
        winsLosses: 'Победа - Проигрыш',
        netDeposit: 'Чистый Депозит',
        lifetimeNetDeposit: 'Общий Чистый Депозит',
        totalDepositsWithdrawals: 'Всего снятий - Всего Депозитов',
        netDepositAvailableFrom: 'Информация доступна только с 6/12/2008',
        saferGamblingNote: {
          title: 'Вы играете ответственно?',
          description: 'Убедитесь, что вы продолжаете получать удовольствие от азартных игр и тратите то, что можете себе позволить. Если вам нужна помощь в этом, ознакомьтесь с нашими {{link}}.',
          link: 'Безопасными Инструментами для Азартных Игр'
        }
      }
    },
    filters: {
      dropdown: {
        transactionsSummary: {
          date: 'В этом месяце',
          filters: 'Фильтры'
        },
        transactionsHistory: {
          date: 'Последние 7 дней',
          filters: 'Фильтры'
        }
      },
      customDateRange: {
        toLabel: 'От',
        labels: {
          from: 'До',
          to: 'От'
        },
        error: 'Пожалуйста, выберите допустимый диапазон дат или выберите другие даты',
        historyLimitation: {
          caption: 'Обратите внимание, транзакции старше 1 года могут быть \
недоступны. Если вы хотите просмотреть эти транзакции,  пожалуйста обратитесь в ',
          link: 'Службу поддержки клиентов'
        }
      },
      predefinedDateRange: {
        sectionName: 'Заданный период времени',
        allDates: 'Все время',
        last7: 'Последние 7 дней',
        last14: 'Последние 14 дней',
        last30: 'Последние 30 дней',
        custom: 'Выбрать диапазон'
      },
      transactionsSummaryDateRange: {
        sectionName: 'Выбрать диапазон дат',
        monthToDate: 'В этом месяце',
        last7days: 'Последние 7 дней',
        last12months: 'Последние 12 месяцев'
      },
      view: {
        sectionName: 'Показать',
        all: 'Все',
        onlyPayments: 'Только платежи',
        excludePayments: 'Исключая платежи',
        onlyWins: 'Только выигрышные',
        onlyLosses: 'Только проигрышные'
      },
      showHideBetTypes: {
        sectionName: 'Показать/Скрыть ставки',
        singles: 'Одиночные',
        multiples: 'Экспресс'
      },
      tabs: {
        all: 'Все',
        sports: 'Спорт',
        gaming: 'Игры'
      },
      applyFilters: 'Применить'
    },
    footer: {
      button: {
        logout: {
          text: 'Выйти'
        }
      },
      link: {
        feedback: 'Отзыв',
        help: 'Помощь'
      }
    },
    oddsFormat: {
      title: 'Виды коэффициентов',
      decimal: 'Десятичный',
      fractional: 'Дробный'
    },
    personalDetails: {
      tabs: {
        contact: 'Контакты',
        marketing: 'Реклама'
      }
    },
    personalDetailsContact: {
      securityMessage: {
        title: 'В William Hill мы серьезно относимся к безопасности и конфиденциальности Вашей учетной записи.',
        text: 'Мы храним ваши контактные данные в надежном месте, включая ваше имя, почтовый адрес, номер телефона \
и Ваш электронный адрес. Чтобы изменить свои данные, пожалуйста, заполните форму ниже и нажмите «Обновить мои данные». \
Обновленные данные будут храниться в наших системах, но не будут отображаться на странице.'
      },
      statusMessage: {
        success: 'Ваши данные были успешно обновлены.',
        failure: 'К сожалению, произошла ошибка.'
      },
      fields: {
        email: {
          label: 'Адрес эл. почты'
        },
        addressLine1: {
          label: 'Адрес 1'
        },
        addressLine2: {
          label: 'Адрес 2'
        },
        addressCity: {
          label: 'Город'
        },
        addressCounty: {
          label: 'Страна/Область (необязательно)'
        },
        addressPostcode: {
          label: 'Индекс'
        },
        country: {
          label: 'Страна',
          defaultValue: 'Пожалуйста, выберите из списка.'
        },
        mobile: {
          label: 'Мобильный номер'
        }
      },
      buttons: {
        submit: 'Обновить мои данные'
      },
      validationRules: {
        email: {
          required: 'Адрес эл. почты не может быть пустым.',
          maxLength: 'Слишком длинный. Максимум 60 символов.',
          email: 'Введите действующий адрес электронной почты.'
        },
        street1: {
          required: 'Адрес является обязательным для заполнения.',
          maxLength: 'Слишком длинный. Максимум 160 символов.',
          pattern: 'Неподходящий символ.'
        },
        street2: {
          required: 'Адрес является обязательным для заполнения.',
          maxLength: 'Слишком длинный. Максимум 160 символов.',
          pattern: 'Неподходящий символ.'
        },
        city: {
          required: 'Город является обязательным полем.',
          pattern: 'Неправильный символ.',
          maxLength: 'Слишком длинный. Максимум 60 символов.'
        },
        county: {
          pattern: 'Неправильный символ.',
          maxLength: 'Слишком длинный. Максимум 60 символов.'
        },
        postcode: {
          required: 'Поле Индекс не может быть пустым.',
          pattern: 'Неправильный символ.',
          maxLength: 'Слишком длинный. Максимум 12 символов.'
        },
        mobile: {
          required: 'Номер телефона не может быть пустым.',
          pattern: 'Неверный символ. Поле может содержать только цифры.',
          minLength: 'Слишком короткий. Минимум 6 символов.',
          maxLength: 'Слишком длинный. Максимум 20 символов.'
        }
      }
    },
    personalDetailsTimezone: {
      statusMessage: {
        success: 'Часовой пояс успешно обновлен',
        failure: 'Что-то пошло не так'
      },
      buttons: {
        updateTimezone: 'Обновить часовой пояс'
      },
      fields: {
        timezones: {
          label: 'Часовой пояс',
          values: {
            TIMEZONE_AFRICA_ADDIS_ABABA: 'Африка/Аддис-Абеба',
            TIMEZONE_AFRICA_JOHANNESBURG: 'Африка/Йоханнесбург',
            TIMEZONE_AMERICA_ANCHORAGE: 'Африка/Анкоридж',
            TIMEZONE_AMERICA_ARGENTINA_BUENOS_AIRES: 'Америка/Аргентина/Буэнос-Айрес',
            TIMEZONE_AMERICA_CHICAGO: 'Америка/Чикаго',
            TIMEZONE_AMERICA_DENVER: 'Америка/Денвер',
            TIMEZONE_AMERICA_LOS_ANGELES: 'Америка/Лос-Анжелес',
            TIMEZONE_AMERICA_NEW_YORK: 'Америка/Нью-Йорк',
            TIMEZONE_AMERICA_SAO_PAULO: 'Америка/Сан-Паулу',
            TIMEZONE_AMERICA_TORONTO: 'Америка/Торонто',
            TIMEZONE_AMERICA_VANCOUVER: 'Америка/Ванкувер',
            TIMEZONE_ASIA_BANGKOK: 'Азия/Бангкок',
            TIMEZONE_ASIA_DHAKA: 'Азия/Дакка',
            TIMEZONE_ASIA_DUBAI: 'Азия/Дубай',
            TIMEZONE_ASIA_HONG_KONG: 'Азия/Гонконг',
            TIMEZONE_ASIA_JERUSALEM: 'Азия/Иерусалим',
            TIMEZONE_ASIA_KARACHI: 'Азия/Карачи',
            TIMEZONE_ASIA_KOLKATA: 'Азия/Калькутта',
            TIMEZONE_ASIA_RANGOON: 'Азия/Рангун',
            TIMEZONE_ASIA_SINGAPORE: 'Азия/Сингапур',
            TIMEZONE_ASIA_TOKYO: 'Азия/Токио',
            TIMEZONE_ATLANTIC_AZORES: 'Атлантика/Азорские о-ва',
            TIMEZONE_ATLANTIC_BERMUDA: 'Атлантика/Бермуды',
            TIMEZONE_AUSTRALIA_ADELAIDE: 'Австралия/Аделаида',
            TIMEZONE_AUSTRALIA_PERTH: 'Австралия/Перт',
            TIMEZONE_AUSTRALIA_SYDNEY: 'Австралия/Сидней',
            TIMEZONE_EUROPE_ATHENS: 'Европа/Афины',
            TIMEZONE_EUROPE_BERLIN: 'Европа/Берлин',
            TIMEZONE_EUROPE_DUBLIN: 'Европа/Дублин',
            TIMEZONE_EUROPE_GIBRALTAR: 'Европа/Гибралтар',
            TIMEZONE_EUROPE_KIEV: 'Европа/Киев',
            TIMEZONE_EUROPE_LONDON: 'Европа/Лондон',
            TIMEZONE_EUROPE_MADRID: 'Европа/Мадрид',
            TIMEZONE_EUROPE_MOSCOW: 'Европа/Москва',
            TIMEZONE_EUROPE_PARIS: 'Европа/Париж',
            TIMEZONE_EUROPE_ROME: 'Европа/Рим',
            TIMEZONE_EUROPE_SOFIA: 'Европа/София',
            TIMEZONE_EUROPE_VIENNA: 'Европа/Вена',
            TIMEZONE_EUROPE_WARSAW: 'Европа/Варшава',
            TIMEZONE_INDIAN_CHRISTMAS: 'Индийский океан/о-в Рождества',
            TIMEZONE_PACIFIC_AUCKLAND: 'Тихий океан/Окленд',
            TIMEZONE_PACIFIC_GUADALCANAL: 'Тихий океан/Гуадалканал',
            TIMEZONE_PACIFIC_HONOLULU: 'Тихий океан/Гонолулу',
            TIMEZONE_PACIFIC_MIDWAY: 'Тихий океан/Мидуэй'
          }
        }
      },
      validationRules: {
        required: 'Выберите часовой пояс'
      }
    },
    personalDetailsMarketing: {
      mainNote: 'Я хотел бы получать новости о бонусах,эксклюзивных предложениях и услугах по электронной почте, СМС или телефону. Вы можете обновлять \
изменять свои настройки в любое время.',
      contactMethodLabel: {
        telephone: 'Звонок',
        email: 'Эл. почта',
        sms: 'SMS'
      },
      error: {
        save: 'Извините, ваши данные не могут быть сохранены в данный момент. Пожалуйста, попробуйте еще раз.'
      },
      disclaimer: {
        text: 'Дисклеймер: ',
        note: 'Обратите внимание, что внесение изменений может занять до 48 часов. \
Мы используем push-уведомления как часть наших услуг. Вы можете управлять настройками push-уведомлений \
на Вашем устройстве. Если Вы используете более одного устройства для доступа к услуге \
Вам нужно настроить параметры на каждом устройстве.'
      }
    },
    loginSecurity: {
      changePassword: 'Изменить пароль',
      currentPassword: 'Текущий пароль',
      newPassword: 'Новый пароль',
      savePassword: 'Сохранить новый пароль',
      passwordUpdated: 'Ваш пароль обновлен',
      genericErrorMessage: 'К сожалению, произошла ошибка.',
      validationRules: {
        currentPassword: {
          required: 'Поле текущего пароля не заполнено.',
          invalidCredentials: 'Неверный пароль'
        },
        newPassword: {
          required: 'Поле нового пароля не заполнено.',
          minLength: 'Новый пароль содежит менее 8 или более 15 символов.',
          maxLength: 'Новый пароль содежит менее 8 или более 15 символов.',
          hasDigit: 'Новый пароль не включает в себя один из следующих: номер, маленькая буква и  заглавная буква.',
          hasUppercaseLetter: 'Новый пароль не включает в себя один из следующих: номер, маленькая буква и  заглавная буква.',
          pattern: 'Новый пароль должен состоять минимум из 8 символов и содержать как минимум одну букву, цифру и символ (! #% & () * +, -. /: <=>? @ ^ _ `| ~).',
          cannotBeEqualToLastPassword: 'Новый пароль не может быть таким же как предыдущий.'
        },
        genericRules: 'Используйте от 8 до 15 символов. Должен содержать как минимум одну букву, цифру и символ (! #% & () * +,. /: <=>? @ ^ _ `| ~). Использование заглавных букв имеет значение. Пробелы не допускаются.'
      }
    },
    accountNetDeposit: {
      title: 'Чистый депозит аккаунта за всё время',
      description: 'Чистая сумма депозита показывает сумму всех транзакций Вашего счета (Снятие средств за вычетом депозитов).',
      accessNote: 'Обратите внимание, что мы можем получить доступ к информации об учетной записи только с 12.06.2008',
      timePeriod: {
        title: 'Период времени чистого депозита',
        description: 'Чистый депозит за выбранный период времени. Все периоды времени начинаются с предыдущего полного дня. Мы отправим эту информацию на Ваш зарегистрированный адрес электронной почты в течение 24 часов.',
        optionsTitle: 'Выберите период',
        optionLabels: {
          LAST_DAY: 'Предыдущий день',
          LAST_WEEK: 'Предыдущие 7 дней',
          LAST_MONTH: 'Предыдущие 30 дней'
        },
        success: 'Мы отправим эту информацию на Ваш зарегистрированный адрес электронной почты в течение 24 часов',
        requestDeposit: 'Отправьте мне информацию о чистом депозите'
      },
      lifetimeNetDepositButton: 'Показать информацию о чистом депозите за все время'
    },
    error: {
      network: {
        text: 'Произошла ошибка сети',
        subText: 'Пожалуйста, повторите попытку через пару минут.',
        retrySubText: 'Пожалуйста, откройте аккаунт заново через несколько минут.'
      },
      graphQL: {
        text: 'К сожалению, мы не смогли получить запрошенные данные.',
        subText: 'Пожалуйста, попробуйте снова через пару минут.',
        retrySubText: 'Пожалуйста, откройте аккаунт заново через несколько минут.'
      },
      retry: 'Попробовать снова',
      iconAlt: 'Дорожный конус'
    },
    confirmationModal: {
      confirmationText: 'да',
      cancellationText: 'нет'
    }
  },
  countries: {
    COUNTRY_AD: 'Андорра',
    COUNTRY_AE: 'ОАЭ',
    COUNTRY_AF: 'Афганистан',
    COUNTRY_AG: 'Антигуа и Барбуда',
    COUNTRY_AI: 'о. Ангилья',
    COUNTRY_AL: 'Албания',
    COUNTRY_AM: 'Армения',
    COUNTRY_AN: 'Нидерландские Антильские о-ва',
    COUNTRY_AO: 'Ангола',
    COUNTRY_AQ: 'Антарктика',
    COUNTRY_AR: 'Аргентина',
    COUNTRY_AS: 'Американские Самоа',
    COUNTRY_AT: 'Австрия',
    COUNTRY_AU: 'Австралия',
    COUNTRY_AW: 'Аруба',
    COUNTRY_AX: 'Аландские о-ва',
    COUNTRY_AZ: 'Азербайджан',
    COUNTRY_BA: 'Босния и Герцеговина',
    COUNTRY_BB: 'о. Барбадос',
    COUNTRY_BC: 'Британская Колумбия',
    COUNTRY_BD: 'Бангладеш',
    COUNTRY_BE: 'Бельгия',
    COUNTRY_BF: 'Буркина-Фасо',
    COUNTRY_BG: 'Болгария',
    COUNTRY_BH: 'Бахрейн',
    COUNTRY_BI: 'Бурунди',
    COUNTRY_BJ: 'Бенин',
    COUNTRY_BM: 'Бермудские о-ва',
    COUNTRY_BN: 'Μπρουνέι Νταρουσαλάμ',
    COUNTRY_BO: 'Боливия',
    COUNTRY_BR: 'Бразилия',
    COUNTRY_BS: 'Багамские о-ва',
    COUNTRY_BT: 'Бутан',
    COUNTRY_BV: 'о. Буве',
    COUNTRY_BW: 'Ботсвана',
    COUNTRY_BY: 'Беларусь',
    COUNTRY_BZ: 'Белиз',
    COUNTRY_CA: 'Канада',
    COUNTRY_CC: 'Кокосовые о-ва (Килинг)',
    COUNTRY_CD: 'Конго',
    COUNTRY_CF: 'Центральная Африканская Республика',
    COUNTRY_CG: 'ДР Конго',
    COUNTRY_CH: 'Швейцария',
    COUNTRY_CI: "Кот-д'Ивуар",
    COUNTRY_CK: 'О-ва Кука',
    COUNTRY_CL: 'Чили',
    COUNTRY_CM: 'Камерун',
    COUNTRY_CN: 'Китай',
    COUNTRY_CO: 'Колумбия',
    COUNTRY_CR: 'Коста-Рика',
    COUNTRY_CU: 'Куба',
    COUNTRY_CV: 'Кабо-Верде',
    COUNTRY_CX: 'о. Рождества',
    COUNTRY_CY: 'Кипр',
    COUNTRY_CZ: 'Чехия',
    COUNTRY_DE: 'Германия',
    COUNTRY_DJ: 'Джибути',
    COUNTRY_DK: 'Дания',
    COUNTRY_DM: 'Доминика',
    COUNTRY_DO: 'Доминиканская Респблика',
    COUNTRY_DZ: 'Алжир',
    COUNTRY_EC: 'Эквадор',
    COUNTRY_EE: 'Эстония',
    COUNTRY_EG: 'Египет',
    COUNTRY_EH: 'Западная Сахара',
    COUNTRY_ER: 'Эритрея',
    COUNTRY_ES: 'Испания',
    COUNTRY_ET: 'Эфиопия',
    COUNTRY_EU: 'Европейский союз',
    COUNTRY_FI: 'Финляндия',
    COUNTRY_FJ: 'Фиджи',
    COUNTRY_FK: 'Фолклендские (Малвинские) о-ва',
    COUNTRY_FM: 'Микронезия',
    COUNTRY_FO: 'Фарерские о-ва',
    COUNTRY_FR: 'Франция',
    COUNTRY_FX: 'Метрополия Франции',
    COUNTRY_GA: 'Габон',
    COUNTRY_GD: 'Гренада',
    COUNTRY_GE: 'Грузия',
    COUNTRY_GF: 'Французская Гвинея',
    COUNTRY_GG: 'Гернси',
    COUNTRY_GH: 'Гана',
    COUNTRY_GI: 'Гибралтар',
    COUNTRY_GL: 'Гренландия',
    COUNTRY_GM: 'Гамбия',
    COUNTRY_GN: 'Гвинея',
    COUNTRY_GP: 'Γουαδελούπη',
    COUNTRY_GQ: 'Экваториальная Гвинея',
    COUNTRY_GR: 'Греция',
    COUNTRY_GS: 'Южная Георгия',
    COUNTRY_GT: 'Гватемала',
    COUNTRY_GU: 'Гуам',
    COUNTRY_GW: 'Гвинея-Бисау',
    COUNTRY_GY: 'Гайана',
    COUNTRY_HK: 'Гонконг',
    COUNTRY_HM: 'Острова Херд и Макдональд',
    COUNTRY_HN: 'Гондурас',
    COUNTRY_HR: 'Хорватия',
    COUNTRY_HT: 'Гаити',
    COUNTRY_HU: 'Венгрия',
    COUNTRY_ID: 'Индонезия',
    COUNTRY_IE: 'Ирландская Республика',
    COUNTRY_IL: 'Израиль',
    COUNTRY_IM: 'Остров Мэн',
    COUNTRY_IN: 'Индия',
    COUNTRY_IO: 'Британская Территория в Индийском Океане',
    COUNTRY_IQ: 'Ирак',
    COUNTRY_IR: 'Иран',
    COUNTRY_IS: 'Исландия',
    COUNTRY_IT: 'Италия',
    COUNTRY_JE: 'Джерси',
    COUNTRY_JM: 'Ямайка',
    COUNTRY_JO: 'Иордания',
    COUNTRY_JP: 'Япония',
    COUNTRY_KE: 'Кения',
    COUNTRY_KG: 'Киргизия',
    COUNTRY_KH: 'Камбоджа',
    COUNTRY_KI: 'Кирибати',
    COUNTRY_KM: 'Коморские о-ва',
    COUNTRY_KN: 'Сент-Китс и Невис',
    COUNTRY_KP: 'Северная Корея',
    COUNTRY_KR: 'Южная Корея',
    COUNTRY_KW: 'Кувейт',
    COUNTRY_KY: 'Каймановы о-ва',
    COUNTRY_KZ: 'Казахстан',
    COUNTRY_LA: 'Лаос',
    COUNTRY_LB: 'Ливан',
    COUNTRY_LC: 'Сент-Люсия',
    COUNTRY_LI: 'Лихтенштейн',
    COUNTRY_LK: 'Sri Lanka',
    COUNTRY_LR: 'Либерия',
    COUNTRY_LS: 'Лесото',
    COUNTRY_LT: 'Литва',
    COUNTRY_LU: 'Люксембург',
    COUNTRY_LV: 'Латвия',
    COUNTRY_LY: 'Ливия',
    COUNTRY_MA: 'Марокко',
    COUNTRY_MC: 'Монако',
    COUNTRY_MD: 'Молдова',
    COUNTRY_ME: 'Черногория',
    COUNTRY_MG: 'Мадагаскар',
    COUNTRY_MH: 'Маршалловы о-ва',
    COUNTRY_MK: 'Северная Македония',
    COUNTRY_ML: 'Мали',
    COUNTRY_MM: 'Мьянма',
    COUNTRY_MN: 'Монголия',
    COUNTRY_MO: 'Макао',
    COUNTRY_MP: 'Северные Марианские о-ва',
    COUNTRY_MQ: 'Мартиника',
    COUNTRY_MR: 'Мавритания',
    COUNTRY_MS: 'Монсеррат',
    COUNTRY_MT: 'Мальта',
    COUNTRY_MU: 'Маврикий',
    COUNTRY_MV: 'Мальдивы',
    COUNTRY_MW: 'Малави',
    COUNTRY_MX: 'Мексика',
    COUNTRY_MY: 'Малайзия',
    COUNTRY_MZ: 'Мозамбик',
    COUNTRY_NA: 'Намибия',
    COUNTRY_NC: 'Новая Каледония',
    COUNTRY_NE: 'Нигер',
    COUNTRY_NF: 'Остров Норфолк',
    COUNTRY_NG: 'Нигерия',
    COUNTRY_NI: 'Никарагуа',
    COUNTRY_NL: 'Нидерланды',
    COUNTRY_NO: 'Норвегия',
    COUNTRY_NP: 'Непал',
    COUNTRY_NR: 'Науру',
    COUNTRY_NU: 'Ниуэ',
    COUNTRY_NZ: 'Новая Зеландия',
    COUNTRY_OM: 'Оман',
    COUNTRY_PA: 'Панама',
    COUNTRY_PE: 'Перу',
    COUNTRY_PF: 'Французская Полинезия',
    COUNTRY_PG: 'Папуа - Новая Гвинея',
    COUNTRY_PH: 'Филиппины',
    COUNTRY_PK: 'Пакистан',
    COUNTRY_PL: 'Польша',
    COUNTRY_PM: 'Сен-Пьер и Микелон',
    COUNTRY_PN: 'Питкэрн',
    COUNTRY_PR: 'Пуэрто-Рико',
    COUNTRY_PS: 'территории Палестины',
    COUNTRY_PT: 'Португалия',
    COUNTRY_PW: 'Палау',
    COUNTRY_PY: 'Парагвай',
    COUNTRY_QA: 'Катар',
    COUNTRY_RE: 'Реюньо́н',
    COUNTRY_RO: 'Румыния',
    COUNTRY_RS: 'Сербия',
    COUNTRY_RU: 'Россия',
    COUNTRY_RW: 'Руанда',
    COUNTRY_SA: 'Саудовская Аравия',
    COUNTRY_SB: 'Соломоновы о-ва',
    COUNTRY_SC: 'Сейшельские о-ва',
    COUNTRY_SD: 'Судан',
    COUNTRY_SE: 'Швеция',
    COUNTRY_SG: 'Сингапур',
    COUNTRY_SH: 'Остров Святой Елены',
    COUNTRY_SI: 'Словения',
    COUNTRY_SJ: 'Шпицберген и Ян-Майен',
    COUNTRY_SK: 'Словакия',
    COUNTRY_SL: 'Сьерра-Леоне',
    COUNTRY_SM: 'Сан-Марино',
    COUNTRY_SN: 'Сенегал',
    COUNTRY_SO: 'Сомали',
    COUNTRY_SR: 'Суринам',
    COUNTRY_ST: 'Сан-Томе и Принсипи',
    COUNTRY_SV: 'Сальвадор',
    COUNTRY_SY: 'Сирия',
    COUNTRY_SZ: 'Свазиленд',
    COUNTRY_TA: 'Тристан-да-Кунья',
    COUNTRY_TC: 'О-ва Теркс и Кайкос',
    COUNTRY_TD: 'Чад',
    COUNTRY_TF: 'Французские Южные территории',
    COUNTRY_TG: 'Того',
    COUNTRY_TH: 'Таиланд',
    COUNTRY_TJ: 'Таджикистан',
    COUNTRY_TK: 'Токелау',
    COUNTRY_TM: 'Туркменистан',
    COUNTRY_TN: 'Тунис',
    COUNTRY_TO: 'Тонга',
    COUNTRY_TP: 'Восточный Тимор',
    COUNTRY_TR: 'Турция',
    COUNTRY_TT: 'Тринидад и Тобаго',
    COUNTRY_TV: 'Тувалу',
    COUNTRY_TW: 'Тайвань',
    COUNTRY_TZ: 'Танзания',
    COUNTRY_UA: 'Украина',
    COUNTRY_UG: 'Уганда',
    COUNTRY_UK: 'Ηνωμένο Βασίλειο',
    COUNTRY_UM: 'Внешние малые острова США',
    COUNTRY_US: 'США',
    COUNTRY_UY: 'Уругвай',
    COUNTRY_UZ: 'Узбекистан',
    COUNTRY_VA: 'Ватикан',
    COUNTRY_VC: 'Сент-Винсент и Гренадины',
    COUNTRY_VE: 'Венесуэла',
    COUNTRY_VG: 'Британские Виргинские о-ва',
    COUNTRY_VI: 'Виргинские о-ва (США)',
    COUNTRY_VN: 'Вьетнам',
    COUNTRY_VU: 'Вануату',
    COUNTRY_WE: 'Западное Самоа',
    COUNTRY_WF: 'О-ва Уоллис и Футуна',
    COUNTRY_WS: 'Самоа',
    COUNTRY_YE: 'Йемен',
    COUNTRY_YT: 'Майотта',
    COUNTRY_ZA: 'ЮАР',
    COUNTRY_ZM: 'Замбия',
    COUNTRY_ZW: 'Зимбабве'
  },
  'ui-kit': uiKit,
  date: {
    today: 'Сегодня',
    months: {
      JAN: uiKit.datepicker.january,
      FEB: uiKit.datepicker.february,
      MAR: uiKit.datepicker.march,
      APR: uiKit.datepicker.april,
      MAY: uiKit.datepicker.may,
      JUN: uiKit.datepicker.june,
      JUL: uiKit.datepicker.july,
      AUG: uiKit.datepicker.august,
      SEP: uiKit.datepicker.september,
      OCT: uiKit.datepicker.october,
      NOV: uiKit.datepicker.november,
      DEC: uiKit.datepicker.december
    },
    monthsNumbered: {
      '01': uiKit.datepicker.january,
      '02': uiKit.datepicker.february,
      '03': uiKit.datepicker.march,
      '04': uiKit.datepicker.april,
      '05': uiKit.datepicker.may,
      '06': uiKit.datepicker.june,
      '07': uiKit.datepicker.july,
      '08': uiKit.datepicker.august,
      '09': uiKit.datepicker.september,
      10: uiKit.datepicker.october,
      11: uiKit.datepicker.november,
      12: uiKit.datepicker.december
    }
  }
};